//

export default `
            id
            name
            category
            canLeave
            active
            classes {
                id
                name
                uri
                active
                color
                formDefinition
            }
            owners {
                id
                name
                image
                username
            }
            attributes
            user {
                id
                name
            }
            teamsCount
            teams(startIndex: 0, stopIndex: 10) {
                role
                    team {
                        id
                        name
                        isSystem
                        users {
                            role
                            user {
                                id
                                name
                                image
                                username
                        }
                    }
                }
            }
            classResourcesCount
            classResources(startIndex: 0, stopIndex: 10) {
                role
                class {
                    id
                    name
                    uri
                }
            }
            entityResourcesCount(excludePermissions: true)
            entityResources(startIndex: 0, stopIndex: 10, excludePermissions: true) {
                entity {
                    id
                    name
                    type
                }
            }
            createdDate
            createdBy {
                id
                name
            }
            modifiedDate
            modifiedBy {
                id
                name
            }
`;
